import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
// import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import {UpgradeModule} from '@angular/upgrade/static';
import { downgradeInjectable } from '@angular/upgrade/static';
import {NgModule, Inject, APP_BOOTSTRAP_LISTENER, APP_INITIALIZER } from '@angular/core';
import {setUpLocationSync} from '@angular/router/upgrade';
import { APP_BASE_HREF } from '@angular/common';
import { RouterModule, UrlHandlingStrategy, UrlTree, Router } from '@angular/router';
import { MatSliderModule } from '@angular/material/slider';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';

import { AppRouterModule } from './app.routing';
import {SharedModule} from './shared';
import {CoreModule} from './core';
import {PowerModule} from './power.module';
import {ShardsModule} from './shards.module';
import {MarketModule} from './market.module';
import {ArenaModule } from './arena.module';
import { DlgDecorationModule } from './dlg-decoration.module';
import {ReportProblemComponent} from './report-problem/report-problem.component';
import { NwMenuModule } from './nw-menu.module';
import {SimulationModeModule} from './simulation-mode.module';
import {WorldMapModule} from './world-map.module';
import {EnterModule} from './enter.module';
import {EnterLegacyModule} from './enter-legacy.module';
import { SeasonWorldLandingModule } from './season-world-landing.module';

// Common Application's Modules
import { ProfileModule } from './profile.module';

import { MenuModule } from './menu.module';
import { SteamNewsModule } from './steam-news.module';

import { VersionService } from './version.service';
import { SessionService, SESSION_SERVER } from './session.service';
import { FeaturesService } from './features.service';
import { AppRouterOutletComponent } from './app-router-outlet.component';
import { SeasonChronicleService } from './shared-services.module/season-chronicle.service';

export class AppUrlHandlingStrategy implements UrlHandlingStrategy {
    private excludes = [
        '/shards2',
        '/market2',
        '/sim/tutorial/1',
        '/sim/tutorial/2',
        '/sim/tutorial/3',
        '/sim/tutorial/4',
        '/sim/tutorial/5'
    ];

    private app2Routes = [
        '/season-world-landing',
        '/arena',
        '/sim',
        '/shards',
        '/market',
        '/nw-menu',
        '/overview/power',
        '/power-promo',
        '/inventory',
        '/map2',
        '/enter-legacy',
        '/enter',
        '/seasons'
    ];

    shouldProcessUrl(url: UrlTree): boolean {
        if (this.excludes.some(i => url.toString().startsWith(i))) {
            return false;
        }

        return this.app2Routes.some(i => url.toString().startsWith(i));
    }

    extract(url: UrlTree): UrlTree {
        return url;
    }

    merge(newUrlPart: UrlTree, rawUrl: UrlTree): UrlTree {
        return newUrlPart;
    }
}

@NgModule({
    declarations: [
        ReportProblemComponent,
        AppRouterOutletComponent
    ],
    entryComponents: [
        ReportProblemComponent,
        AppRouterOutletComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        MatSliderModule,
        MatInputModule,
        MatCheckboxModule,
        MatFormFieldModule,

        CoreModule,
        SharedModule,
        UpgradeModule,

        MenuModule,
        SteamNewsModule,
        SimulationModeModule,
        PowerModule,
        MarketModule,
        ArenaModule,
        DlgDecorationModule,
        ShardsModule,
        NwMenuModule,
        WorldMapModule,
        EnterModule,
        EnterLegacyModule,
        SeasonWorldLandingModule,
        RouterModule,
        AppRouterModule,

        // Common Application's Modules
        ProfileModule
    ],
    exports: [
        RouterModule
    ],
    providers: [
        VersionService,
        SessionService,
        FeaturesService,
        SeasonChronicleService,
        { provide: UrlHandlingStrategy, useClass: AppUrlHandlingStrategy },
        { provide: APP_BASE_HREF, useValue : '!' },
        { provide: APP_INITIALIZER, useFactory: versionProviderFactory, deps: [VersionService], multi: true }
    ]
})
export class AppModule {
    constructor(
        @Inject(APP_BOOTSTRAP_LISTENER) private bootstrapListeners: (() => void)[],
        private upgrade: UpgradeModule,
        private router: Router,
        private _versionSrv: VersionService
    ) {
    }

    ngDoBootstrap() {
        this.upgrade.bootstrap(document.body, ['app'], {strictDi: true});
        // this.bootstrapListeners.forEach(listener => listener());
        this.router.initialNavigation();

        this._versionSrv.afterUpgrade();

        this.upgrade.$injector.get('$rootScope')
            .$on('$locationChangeStart', (event, next, prev) => {
                if (next === prev) {
                    return;
                }

                if (event.defaultPrevented) {
                    return;
                }

                this.router.navigateByUrl(next.replace(/.+#!/, ''));
        });
        // setUpLocationSync(this.upgrade);
    }
}

function versionProviderFactory(versionSrv: VersionService) {
    return async () => {
        let versionData = null;
        try {
            const { apiUrl } = JSON.parse(localStorage.getItem(SESSION_SERVER));

            versionData = await versionSrv.getData(apiUrl);
        } catch (err) {
        }

        if (!versionData) {
            try {
                let apiUrl = window.CONFIG.API_URL;

                versionData = await versionSrv.getData(apiUrl);
            } catch (err) {
            }
        }

        versionSrv.data = versionData;
    };
}

declare const angular: angular.IAngularStatic;

angular.module('app')
    .factory('FeaturesService', downgradeInjectable(FeaturesService) as any);

angular.module('app')
    .factory('VersionService', downgradeInjectable(VersionService) as any);

angular.module('app')
    .factory('SeasonChronicleService', downgradeInjectable(SeasonChronicleService) as any);
    